import { Button, Form, Space } from 'antd';
import Select from 'react-select';
import React from 'react';
import { useSelector } from 'react-redux';
import { SELECT_STYLES } from '../../../main/utils/const';
import { SingleSignupListItem } from './SingularSignupListItem';
import GlobalContext from '../../../main/utils/GlobalContext';
import { USER_ROLES } from '../../utils/factories';

export const ElevatedPrivilegesSignupLinks = ({
  addSignupCallback,
  deleteSignupCallback,
  elevatedSignupLinks,
}) => {
  const { locales } = React.useContext(GlobalContext);
  const { user } = useSelector((state) => state);
  const [selectedRole, setSelectedRole] = React.useState('lecturer');

  const showAdminRoleSelector = user?.current?.role === 'super_admin';

  const elevatedRoles = USER_ROLES.filter((role) =>
    ['admin', 'lecturer'].includes(role.value),
  );
  const availableRoles = elevatedRoles.filter(
    (role) =>
      role.value === 'lecturer' ||
      (role.value === 'admin' && showAdminRoleSelector),
  );

  const roleOptions = availableRoles.map((role) => ({
    value: role.value,
    label: role.label,
  }));

  const generateSignupLink = () => {
    addSignupCallback(selectedRole);
  };

  const onDelete = (id) => {
    deleteSignupCallback(id);
  };

  const handleRoleChange = (role) => {
    setSelectedRole(role.value);
  };

  const renderLinks = () => {
    return elevatedSignupLinks.map((data, i) => {
      return (
        <SingleSignupListItem
          key={i}
          signup={data}
          onDelete={onDelete}
          roleLabels={availableRoles}
        />
      );
    });
  };

  return (
    <>
      <Form
        onFinish={generateSignupLink}
        style={{ width: '100%' }}
        layout="vertical"
      >
        <div className="mt-20">
          <Form.Item
            label={locales.admin.adminEducatorDashboard.role}
            name="role"
            className="admin-input-label"
            rules={[
              {
                required: true,
                message: locales.admin.adminEducatorDashboard.roleIsRequired,
              },
            ]}
          >
            <Select
              options={roleOptions}
              className="bmc-form-select"
              styles={SELECT_STYLES}
              placeholder={locales.admin.adminEducatorDashboard.chooseType}
              onChange={handleRoleChange}
            />
          </Form.Item>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Space align="end">
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100%' }}
              >
                {locales.admin.generateSignupLink}
              </Button>
            </Space>
          </div>
        </div>
      </Form>
      <div className="mt-20 admin-elevated-privilege-links">
        <table>
          <thead>
            <tr>
              <th>{locales.admin.status}</th>
              <th>{locales.admin.adminEducatorDashboard.role}</th>
              <th>{locales.admin.information}</th>
              <th>{locales.admin.copy}</th>
              <th>{locales.admin.delete}</th>
            </tr>
          </thead>
          <tbody>{renderLinks()}</tbody>
        </table>
      </div>
    </>
  );
};
